/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityReportResource } from './';
import {
    ActivityReportResourceFromJSON,
    ActivityReportResourceFromJSONTyped,
    ActivityReportResourceToJSON,
} from './';
import type { ActivityReportStatusResource } from './';
import {
    ActivityReportStatusResourceFromJSON,
    ActivityReportStatusResourceFromJSONTyped,
    ActivityReportStatusResourceToJSON,
} from './';
import type { PaymentMethod } from './';
import {
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
} from './';
import type { ReportTypeResource } from './';
import {
    ReportTypeResourceFromJSON,
    ReportTypeResourceFromJSONTyped,
    ReportTypeResourceToJSON,
} from './';
import type { TemporalUnitResource } from './';
import {
    TemporalUnitResourceFromJSON,
    TemporalUnitResourceFromJSONTyped,
    TemporalUnitResourceToJSON,
} from './';
import type { WorkAmountResource } from './';
import {
    WorkAmountResourceFromJSON,
    WorkAmountResourceFromJSONTyped,
    WorkAmountResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface DetailedActivityReportResource
 */
export interface DetailedActivityReportResource extends ActivityReportResource {
    /**
     * Map of work amounts, key is the day of month and value is the decimal representing how long the freelancer worked on that day
     * @type {{ [key: string]: WorkAmountResource; }}
     * @memberof DetailedActivityReportResource
     */
    workAmounts: { [key: string]: WorkAmountResource; };
}

/**
 * Check if a given object implements the DetailedActivityReportResource interface.
 */
export function instanceOfDetailedActivityReportResource(value: object): value is DetailedActivityReportResource {
    if (!('workAmounts' in value) || value['workAmounts'] === undefined) return false;
    return true;
}

export function DetailedActivityReportResourceFromJSON(json: any): DetailedActivityReportResource {
    return DetailedActivityReportResourceFromJSONTyped(json, false);
}

export function DetailedActivityReportResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DetailedActivityReportResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ActivityReportResourceFromJSONTyped(json, ignoreDiscriminator),
        'workAmounts': (mapValues(json['workAmounts'], WorkAmountResourceFromJSON)),
    };
}

export function DetailedActivityReportResourceToJSON(value?: DetailedActivityReportResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ActivityReportResourceToJSON(value, true),
        'workAmounts': (mapValues(value['workAmounts'], WorkAmountResourceToJSON)),
    };
}

